<template>
  <v-row justify="center" class="search-bar my-10">
    <v-expansion-panels hover>
      <v-expansion-panel class="py-4 px-8">
        <v-expansion-panel-header
          expand-icon="mdi-menu-down"
          style="width: 220px; font-size: 20px"
        >
          さらに絞り込む
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>複数選択可。全項目に条件を指定しなくても検索できます。</p>
          <v-divider></v-divider>
          <v-row align="center" class="my-3">
            <v-col cols="2">
              キーワード
            </v-col>
            <v-col sm="6" style="margin-left: -4px">
              <v-text-field
                label="気になるキーワードを入力"
                class="rounded-sm"
                hide-details
                outlined
                clearable
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" class="my-3">
            <v-col cols="2">
              所属教室
            </v-col>
            <v-col sm="6">
              <v-row>
                <v-card
                  v-for="(area, index) in areas"
                  :key="index"
                  class="ma-2 py-2 px-4 rounded-sm eachCard"
                  outlined
                  tile
                  hover
                  @click="areaSelected(index)"
                  :class="changeAreaColor(index)"
                >
                  {{ area.areaName }}
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" class="my-3">
            <v-col cols="2">
              コース
            </v-col>
            <v-col sm="10">
              <v-row>
                <v-card
                  v-for="(course, index) in courses"
                  :key="index"
                  class="ma-2 py-2 px-4 rounded-sm eachCard"
                  outlined
                  tile
                  hover
                  @click="courseSelected(index)"
                  :class="changeCourseColor(index)"
                >
                  {{ course.courseName }}
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <!-- <v-row align="center" class="my-3">
            <v-col cols="2">
              使用技術 / ツール
            </v-col>
            <v-col sm="10">
              <v-row>
                <v-card
                  v-for="(skill, index) in skills"
                  :key="index"
                  class="ma-2 py-2 px-3 rounded-sm eachCard"
                  outlined
                  tile
                  hover
                  @click="skillSelected(index)"
                  :class="changeSkillColor(index)"
                  style="font-size: 16px"
                >
                  {{ skill.skillName }}
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider> -->
          <div class="text-center mt-12 mb-3">
            <v-btn
              class="mx-1 rounded-sm"
              outlined
              color="#F4A616"
              style="width: 164px"
            >
              リセットする
            </v-btn>
            <v-btn
              class="mx-1 rounded-sm"
              color="#F4A616"
              dark
              style="width:164px; box-shadow:none"
              >検索する</v-btn
            >
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
export default {
  name: "PcSearch",
  data: () => ({
    min: 0,
    max: 24,
    slider: 12,
    range: [0, 3],
  }),

  computed: {
    areas() {
      return this.$store.state.areas
    },
    courses() {
      return this.$store.state.courses
    },
  },

  methods: {
    changeAreaColor(index) {
      return {
        clicked: this.areas[index].selected,
      }
    },
    changeCourseColor(index) {
      return {
        clicked: this.courses[index].selected,
      }
    },
    areaSelected(index) {
      this.$store.commit("switchArea", index)
    },
    courseSelected(index) {
      this.$store.commit("switchCourse", index)
    },
  },
}
</script>

<style lang="scss">
.search-bar {
  width: 85%;
  margin: 0 auto;
  padding: 0 12px;

  .v-expansion-panel {
    box-shadow: 0px 0px 20px #3c3c3c29;
    border-radius: 8px;
  }

  .v-expansion-panel::before {
    box-shadow: none;
  }

  .clicked {
    background-color: #747474 !important;
    color: #fff !important;
  }

  .eachCard {
    border: solid 1px rgba(0, 0, 0, 0.38);
    color: #575757;
    font-size: 14px !important;
  }
}
</style>
